import { c as _c } from "react/compiler-runtime";
import { FileText } from "react-feather";
import { Distribution, Donation, TaxYearlyReport } from "../../../../../models";
import { thousandize } from "../../../../../util/formatting";
import style from "./TaxYearlyReportListSupplemental.module.scss";
import { AggregatedImpactTableConfiguration, DonationsAggregateImpactTable } from "../../../donations/DonationsAggregateImpactTable/DonationsAggregateImpactTable";
export const TaxYearlyReportListSupplemental: React.FC<{
  report: TaxYearlyReport;
  donations: Donation[];
  distribtionMap: Map<string, Distribution>;
  aggregateImpactConfig: AggregatedImpactTableConfiguration;
}> = t0 => {
  const $ = _c(25);
  const {
    report,
    donations,
    distribtionMap,
    aggregateImpactConfig: aggregateImpactTexts
  } = t0;
  if (report.sumDonations == 0) {
    return null;
  }
  let t1;
  if ($[0] !== report.year) {
    t1 = <h2>{report.year}</h2>;
    $[0] = report.year;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={style.printLink} onClick={_temp}><FileText size="1rem" /><span>Skriv ut</span></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className={style.header}>{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== aggregateImpactTexts || $[6] !== distribtionMap || $[7] !== donations) {
    t4 = <div className={style.impactWrapper}><DonationsAggregateImpactTable donations={donations} distributionMap={distribtionMap} configuration={aggregateImpactTexts} defaultExpanded={false} /></div>;
    $[5] = aggregateImpactTexts;
    $[6] = distribtionMap;
    $[7] = donations;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== report.units) {
    t5 = thousandize(report.units.reduce(_temp2, 0));
    $[9] = report.units;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <h3 data-cy="yearly-tax-report-sum">{t5} kr</h3>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== report.year) {
    t7 = <span>Totalt sum donert i {report.year} som er skattefradragsgodkjent</span>;
    $[13] = report.year;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className={style.summation}>{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className={style.taxMessageInfo}><span>Beløpet vil være registrert i skattemeldingen når du får den (Gave og arv → Gave til frivillige organisasjoner).</span></div>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={style.orgInfo}><strong>Effektiv Altruisme Norge</strong><span> Org.nr 919 809 140</span></div>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className={style.mobileListHeader}><i>Skattenheter</i></div>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t3 || $[22] !== t4 || $[23] !== t8) {
    t12 = <>{t3}{t4}{t8}{t9}{t10}{t11}</>;
    $[21] = t3;
    $[22] = t4;
    $[23] = t8;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
function _temp() {
  return window.print();
}
function _temp2(acc, u) {
  return acc + u.sumDonations;
}